import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputDecimal from '../../commons/form/InputDecimal'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

class RatingMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  submitDocument (values) {
    const rating = {
      ratingId: values.ratingId,
      organizedUnitId: values.organizedUnitId,
      name: values.name,
      description: values.description,
      import: values.import
    }

    this.props.actions.submitRating(rating)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.rating)
      this.setState({
        rating: this.props.rating,
        deleted: false,
        values: 1
      })
    }
    if (!this.state.deleted && this.props.rating !== null && (this.props.rating?.value)?.length > this.state.values) {
      const count = (this.props.rating?.value)?.length
      this.setState({ values: count })
    }
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      combos: { organizedUnitsAllCombo }
    } = this.props
    const tKey = 'MASTERS.RATING_MASTERS.MODAL.'
    return (
      <Modal id="ratingMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeRatingMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onReset={this.handleFormReset} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeRatingMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">

              <Field
                component={InputText}
                colWidth={66} // 25, 33, 50, 75, 100 default=25
                id="name"
                name="name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                maxLength={50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="description"
                name="description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                maxLength={50}
              />
              <Field
                component={InputDecimal}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="import"
                name="import"
                controlLabel={t(`${tKey}IMPORT`)}
                placeholder={t(`${tKey}IMPORT`)}
                maxLength={50}
              />
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
              <Button
                id="role-modal-submit-button"
                className="_Btn cancel"
                type="reset"
                onClick={this.props.actions.closeRatingMasterModal}>
                {t(`${tKey}CANCEL_BUTTON`)}
              </Button>
            </Col>

          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editRating',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.RATING_MASTERS.VALIDATION.'
    if (!values.name) {
      error.name = props.t(`${tKey}NAME`)
    }
    if (!values.description) {
      error.description = props.t(`${tKey}DESCRIPTION`)
    }
    if (!values.organizedUnitId) {
      error.organizedUnitId = props.t(`${tKey}OU`)
    }
    if (!values.import) {
      error.import = props.t(`${tKey}IMPORT`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(RatingMasterModal)
